export const customThemeQuartz = {
    browserColorScheme: 'light',
    fontFamily: 'Roboto, sans-serif',
    headerFontFamily: 'Roboto, sans-serif',
    foregroundColor: '#333333',
    backgroundColor: '#FAFAFA',
    cellTextColor: '#333333',
    fontSize: 12,
    rowBorder: true,
    columnBorder: true,
    headerBackgroundColor: '#FAFAFA',
    headerTextColor: '#333333',
    headerFontSize: 14,
    headerFontWeight: 400,
    headerColumnBorder: true,
    headerVerticalPaddingScale: 0.7,
    rowVerticalPaddingScale: 0.7,
    sidePanelBorder: true,
    wrapperBorder: false,
    columnDropCellBackgroundColor: '#0095FF26',
    columnDropCellBorder: false,
    rowHoverColor: '#e3ecf2'
};

export const agGridThemeActivityLog = {
    ...customThemeQuartz,
    columnBorder: false,
    headerColumnBorder: false,
    headerRowBorder: false,
    rowBorder: false,
    wrapperBorder: false,
    headerBackgroundColor: '#E3ECF2',
    headerTextColor: '#333333',
    headerFontSize: 14,
    headerFontWeight: 600
};
